import { Checkbox } from "@/components/ui/checkbox";
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormMessage,
} from "@/components/ui/form";
import { Label } from "@/components/ui/label";
import { useTranslation } from "react-i18next";
import { usePayrollTypesDictionary } from "../hooks/usePayrollTypesDictionary";

interface PayrollTypeBlockTimesheetFieldProps {
  disabled?: boolean;
}

export default function PayrollTypeBlockTimesheetField({
  disabled = false,
}: PayrollTypeBlockTimesheetFieldProps) {
  const { t } = useTranslation();
  const { ns } = usePayrollTypesDictionary();

  return (
    <div className="col-span-full">
      <FormField
        name="block_timesheet_and_visits_when_payroll_created"
        render={({ field }) => (
          <FormItem className="flex flex-col pt-6">
            <FormControl>
              <Label className="flex items-center font-normal">
                <Checkbox
                  className="mr-2"
                  checked={field.value}
                  onCheckedChange={field.onChange}
                  disabled={disabled}
                  {...field}
                />
                {t(
                  `${ns}.fields.block_timesheet_and_visits_when_payroll_created`,
                )}
              </Label>
            </FormControl>
            <FormDescription>
              {t(
                `${ns}.fields.block_timesheet_and_visits_when_payroll_created.description`,
              )}
            </FormDescription>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
}
